'use client'
import { createContext, useContext } from 'react'
import { OIDCService } from '../utils/services/oidc.service'


export type OidcContextValue = {
  signinRedirectCallback: () => void
  logout: () => void
  signoutRedirectCallback: () => void
  isAuthenticated: () => any
  isTokenExpired: () => any
  getExpiryTime: () => void
  signinRedirect: () => void
  signinSilentCallback: () => void
  signinSilent: () => void
  changePassword: () => void
}

// ** Create Context
export const OidcContext = createContext<OidcContextValue>({
  signinRedirectCallback: () => ({}),
  logout: () => ({}),
  signoutRedirectCallback: () => ({}),
  isAuthenticated: () => Boolean,
  isTokenExpired: () => ({}),
  getExpiryTime: () => ({}),
  signinRedirect: () => ({}),
  signinSilentCallback: () => ({}),
  signinSilent: () => ({}),
  changePassword: () => ({}),
})

export type Auth = {
  children: React.ReactNode
}

export const OidcProvider = ({ children }: { children: React.ReactNode }) => {
  return <OidcContext.Provider value={(new OIDCService())}>{children}</OidcContext.Provider>
}

export const OidcConsumer = OidcContext.Consumer

export const useOIDC = (): OidcContextValue => useContext(OidcContext)